import React, { useContext, useEffect, useState } from 'react';
import { SettingsProps } from './Settings.props';
import './Settings.styles.css';
import { PageHeader } from '../../components/organisms/PageHeader';
import { SettingCard } from '../../components/molecules/SettingCard';
import { Box, Divider, IconButton, Stack, Tooltip, useTheme } from "@mui/material";
import { getSettings, updateSetting } from "../../api/emailTriage";
import {
  ACCOUNT_DATA_KEYS,
  ADMIN_ROLE,
  SETTING_BLOCK_LIST,
  SETTING_TYPE_AUTOMATION_RULE,
  SETTING_TYPE_REPORTED_EMAILS_ACTIONS,
  UPDATE_SETTINGS_TASKS
} from "../../constants/contants";
import ChangeWithZone from "../../hoc/ChangeWithZone";
import { BaseDomainSetting } from "../../components/organisms/BaseDomainSetting";
import { GlobalContext } from "../../context/GlobalState";
import { CredentialCard } from "../../components/molecules/CredentialCard";
import { useTranslation } from "react-i18next";
import { MicrosoftTenantConnectionSetting } from "../../components/organisms/MicrosoftTenantConnectionSetting";
import { determineCredentialsStatus, getNestedProperty, getUserData, SettingsData, defaultSetting } from "../../utils/common";
import { LoadingPage } from "../../components/organisms/LoadingPage";
import { useLocation, useNavigate } from "react-router-dom";
import HelpIcon from "@mui/icons-material/Help";
import { useRoleContext } from "../../context/RoleContext";
import LoginAzure from "../../components/services/LoginAzure";

interface DataInterface {
  [ACCOUNT_DATA_KEYS.AUTO_BLOCK_LIST]: SettingsData;
  [ACCOUNT_DATA_KEYS.BLOCK_LIST]: SettingsData;
  [ACCOUNT_DATA_KEYS.AUTO_PHISH_CLEAR]: SettingsData;
  [ACCOUNT_DATA_KEYS.PHISH_CLEAR]: SettingsData;
  onBeforeLogin: any;
  onRemoveCredential: any;
  setPageLoading: any;
}

const navigationLinks = [
  {
    name: 'Settings'
  }
]

const generateAutomationComponent = (config: DataInterface, theme:any, t:any) => {

  const autoPhishClearSetting: SettingsData = config[ACCOUNT_DATA_KEYS.AUTO_PHISH_CLEAR] ?? defaultSetting

    const autoPhishClear:any = <Box className={"automation-rule-phish-clear-wrapper"}>
        <Box className={"automation-rule-phish-clear-title"}>
            {
                autoPhishClearSetting["total_rules"] && autoPhishClearSetting["total_rules"] > 0 ? <div
                    dangerouslySetInnerHTML={{
                        __html: t("credentialCard.phish_clear_title",
                            {
                                usedNumber: autoPhishClearSetting["total_used"],
                                totalNumber: autoPhishClearSetting["total_rules"]
                            })
                    }}>
                </div> : <div dangerouslySetInnerHTML={{__html: t("credentialCard.phish_clear_no_automation_rule_active")}}></div>
            }
        </Box>
        <CredentialCard payload={{
            service_key: ACCOUNT_DATA_KEYS.PHISH_CLEAR,
            service_id: ACCOUNT_DATA_KEYS.AUTO_PHISH_CLEAR,
            title: t("credentialCard.manual_action_title"),
            authenticated: autoPhishClearSetting[ACCOUNT_DATA_KEYS.AUTHENTICATED],
            accountName: autoPhishClearSetting[ACCOUNT_DATA_KEYS.ACCOUNT_NAME],
            accountEmail: autoPhishClearSetting[ACCOUNT_DATA_KEYS.ACCOUNT_EMAIL],
            loginAt: autoPhishClearSetting[ACCOUNT_DATA_KEYS.LOGIN_AT],
            lastUpdate: autoPhishClearSetting[ACCOUNT_DATA_KEYS.LAST_UPDATE],
            expireAt: autoPhishClearSetting[ACCOUNT_DATA_KEYS.EXPIRE_AT],
            daysRemaining: autoPhishClearSetting[ACCOUNT_DATA_KEYS.DAYS_REMAINING],
        }}
            onRemoveCredential={()=> {
                    config['setPageLoading']?.(true)
                    updateSetting({
                        task: UPDATE_SETTINGS_TASKS.DISCONNECT_AUTO_PHISH_CLEAR,
                    }).then((response) => {
                        config['onRemoveCredential']?.()
                    }).catch(e => {
                        config['setPageLoading']?.(false)
                    })
                }
            }
            onLogIn={(isReLogin = false) => {
                config['onBeforeLogin']?.()
                LoginAzure({
                    service: "setting_auto_phish_clear",
                    sourceId: "",
                    isReLogin,
                })
            }}
        ></CredentialCard>
    </Box>

    let autoBlocklistSetting: SettingsData = config[ACCOUNT_DATA_KEYS.AUTO_BLOCK_LIST] ?? defaultSetting
    const autoBlockList = <Box className={"automation-rule-block-list-wrapper"}>
        <Box className={"automation-rule-phish-clear-title"}>
            {
                autoBlocklistSetting["total_rules"] && autoBlocklistSetting["total_rules"] > 0 ? <div
                    dangerouslySetInnerHTML={{
                        __html: t("credentialCard.block_list_title",
                            {
                                usedNumber: autoBlocklistSetting["total_used"],
                                totalNumber: autoBlocklistSetting["total_rules"]
                            })
                    }}>
                </div> : <div dangerouslySetInnerHTML={{__html: t("credentialCard.block_list_no_automation_rule_active")}}></div>
            }
        </Box>
        <CredentialCard payload={{
            service_key: 'block_list',
            service_id: 'auto_block_list',
            title: t("credentialCard.manual_action_title"),
            authenticated: autoBlocklistSetting[ACCOUNT_DATA_KEYS.AUTHENTICATED],
            accountName: autoBlocklistSetting[ACCOUNT_DATA_KEYS.ACCOUNT_NAME],
            accountEmail: autoBlocklistSetting[ACCOUNT_DATA_KEYS.ACCOUNT_EMAIL],
            loginAt: autoBlocklistSetting[ACCOUNT_DATA_KEYS.LOGIN_AT],
            lastUpdate: autoBlocklistSetting[ACCOUNT_DATA_KEYS.LAST_UPDATE],
            expireAt: autoBlocklistSetting[ACCOUNT_DATA_KEYS.EXPIRE_AT],
            daysRemaining: autoBlocklistSetting[ACCOUNT_DATA_KEYS.DAYS_REMAINING],
        }}
            onRemoveCredential={()=> {
                    config['setPageLoading']?.(true)
                    updateSetting({
                        task: UPDATE_SETTINGS_TASKS.DISCONNECT_AUTO_BLOCK_LIST,
                    }).then((response) => {
                        config['onRemoveCredential']?.()
                    }).catch(e => {
                        config['setPageLoading']?.(false)
                    })
                }
            }
            onLogIn={(isReLogin = false) => {
                config['onBeforeLogin']?.()
                LoginAzure({
                    service: "setting_auto_block_list",
                    sourceId: "",
                  isReLogin,
                })
            }}
        ></CredentialCard>
    </Box>

    return <Box className={"automation-rules-settings-wrapper"} sx={{gap: 4, display: 'flex', width: '100%', maxWidth: '88%', marginTop: 2, paddingTop: 2}}>
        {autoPhishClear}
        {autoBlockList}
    </Box>
}


export const SettingFull: React.FC<SettingsProps> = () => {
  const [statusSettings, setStatusSetting] = useState<any>({})
  const [loadingPage, setLoadingPage] = useState(false)
  const [loadingFullPage, setLoadingFullPage] = useState(false)
  const [roleUser, setRoleUser] = useState('')
  const localStorageUserData = localStorage.getItem('userData');
  const [tenantData, setTenantData] = useState<any>(null)
  const [accountsData, setAccountsData] = useState<any>({})
  const { setting, setAutomationRulesStatus, setCredentialsStatus, setCredentialsDates } = useRoleContext()
  const { globalState } = useContext(GlobalContext);
  const isMS365 = globalState.ms365
  const theme = useTheme()
  const { t } = useTranslation();
  const [automationComponents, setAutomationComponents] = useState<any>(<></>)

  const location = useLocation();
  const navigate = useNavigate();
  const locationState = location.state as {
      service?: string
      message?: string
      status?: boolean
      sourceId?: string
  };

  const currentUser = getUserData()

  const reloadCredentials = () => {
    getTenantData();
    getAccountsData(true)
  }

  const getTenantData = () => {
    // setTenantData(undefined)
    // getSettings({
    //     'task': 'get_tenant_data',
    //     'user_id': currentUser['id'],
    //     'user_email': currentUser['email'],
    //     'user_role': currentUser['role']
    // }).then((response) => {
    //   const responseData:any = response.data
    //
    // })
  }

  const setAutoRuleStatus = (accountData: any) => {
      const ruleData = accountData?.rules as never[]
      setAutomationRulesStatus({
          phishClear: ruleData.some(rule => {
              const user_login_present = !!rule['phish_clear_user_login'] && rule['phish_clear_user_login'] !== '';
              return rule['is_active'] && (rule['phish_clear'] || (accountsData.auto_phish_clear?.expired_at === 'error' && user_login_present))
          }),
          blockList: ruleData.some(rule => {
              const user_login_present = !!rule['block_list_user_login'] && rule['block_list_user_login'] !== '';
              return rule['is_active'] && (rule['block_list'] || (accountsData.auto_block_list?.expired_at === 'error' && user_login_present))
          }),
      });
  }

  const getAccountsData = (showLoading=false) => {
      if(showLoading){
          setLoadingFullPage(true)
      }
      setTenantData(undefined)
      getSettings({
        'task': 'get_accounts_data',
        'user_id': currentUser['id'],
        'user_email': currentUser['email'],
        'user_role': currentUser['role']
    }).then((response) => {
      const responseData:any = response.data
      const payload = responseData
      setTenantData(responseData)
      payload['onRemoveCredential'] = () => { reloadCredentials() }
      payload['onBeforeLogin'] = () => { setLoadingFullPage(true) }
      payload['setPageLoading'] = (value:boolean) => { setLoadingFullPage(value) }
      setAutomationComponents(generateAutomationComponent(payload, theme, t))
      setAccountsData(responseData)
      // setAutoRuleStatus(responseData)
      if(showLoading){
        setLoadingFullPage(false)
      }
    })
  }

  // Helper function to get days remaining with fallback
  const getAccountDataByKey = (key: ACCOUNT_DATA_KEYS, dataKey = ACCOUNT_DATA_KEYS.DAYS_REMAINING) =>
    accountsData[key]?.[dataKey] ?? defaultSetting[dataKey];

  useEffect(() => {
    if(localStorageUserData) {
      const parseUserData = JSON.parse(localStorageUserData)
      setRoleUser(parseUserData["role"])
    }
    setLoadingPage(true)
    getTenantData()
    getAccountsData()
    getSettings().then((response) => {
      const data:any = response.data
      const statuses = {}
      for(let i = 0; i < data.length; i++) {
        Object.assign(statuses, {[data[i]['setting_type']]: data[i]['setting_value']})
      }
      setStatusSetting(statuses)
      setLoadingPage(false)
    })
  },[])

    useEffect(() => {
        if (locationState) {
          navigate('.', { replace: true, state: null });
        }
    }, [locationState, navigate]);

  useEffect(() => {
    if (tenantData && !!Object.keys(accountsData).length) {
      setCredentialsStatus(determineCredentialsStatus(tenantData, accountsData));
      setCredentialsDates({
        autoPhishClear: accountsData.auto_phish_clear?.expired_at,
        autoBlockList: accountsData.auto_block_list?.expired_at,
      });
    }
  }, [accountsData, tenantData, setCredentialsStatus]);

  const manualPhishClearSetting: SettingsData = accountsData[ACCOUNT_DATA_KEYS.PHISH_CLEAR] ?? defaultSetting;
  const manualBlocklistSetting: SettingsData = accountsData[ACCOUNT_DATA_KEYS.BLOCK_LIST] ?? defaultSetting;

    return (
        <Box className='setting-page page-content-wrapper'>
            <PageHeader pageTitle={navigationLinks[0].name}/>
            <Box className='page-content-body'>
                {
                    isMS365 && tenantData && accountsData ? <MicrosoftTenantConnectionSetting payLoad={{
                        tenantId: tenantData['tenantId'],
                        featureListInfo: [
                          {
                            title: "Automation Phish Clear",
                            expireAt: getAccountDataByKey(ACCOUNT_DATA_KEYS.AUTO_PHISH_CLEAR, ACCOUNT_DATA_KEYS.EXPIRE_AT),
                            daysRemaining: getAccountDataByKey(ACCOUNT_DATA_KEYS.AUTO_PHISH_CLEAR),
                            connectionStatus: tenantData['automationPhishClear']
                          },
                          {
                            title: "Automation Block List",
                            expireAt: getAccountDataByKey(ACCOUNT_DATA_KEYS.AUTO_BLOCK_LIST, ACCOUNT_DATA_KEYS.EXPIRE_AT),
                            daysRemaining: getAccountDataByKey(ACCOUNT_DATA_KEYS.AUTO_BLOCK_LIST),
                            connectionStatus: tenantData['automationBlocklist']
                          },
                          {
                            title: "Manual Phish Clear",
                            expireAt: getAccountDataByKey(ACCOUNT_DATA_KEYS.PHISH_CLEAR, ACCOUNT_DATA_KEYS.EXPIRE_AT),
                            daysRemaining: getAccountDataByKey(ACCOUNT_DATA_KEYS.PHISH_CLEAR),
                            connectionStatus: tenantData['phishClear']
                          },
                          {
                            title: "Manual Block List",
                            expireAt: getAccountDataByKey(ACCOUNT_DATA_KEYS.BLOCK_LIST, ACCOUNT_DATA_KEYS.EXPIRE_AT),
                            daysRemaining: getAccountDataByKey(ACCOUNT_DATA_KEYS.BLOCK_LIST),
                            connectionStatus: tenantData['blocklist']
                          }
                        ],
                    }}
                    onBeforeDisconnect = {() => { setLoadingFullPage(true) }}
                    onAfterDisconnected = {() => {setLoadingFullPage(false)}}
                    onDisconnected = {()=> {reloadCredentials()}}
                    /> : <></>
                }

                { isMS365 &&  <SettingCard
                            loading={loadingPage}
                            title={<Box sx={{fontSize: "18px"}}><strong>Admin Credentials</strong> for Automation Rules</Box>}
                            description="Enable automation rules functionality"
                            status={true}
                            type={SETTING_TYPE_AUTOMATION_RULE}
                            component = {automationComponents}
                            showDisableDialog={
                                getNestedProperty(accountsData, ['auto_block_list','authenticated'], false) ||
                                getNestedProperty(accountsData, ['auto_phish_clear','authenticated'], false)
                            }
                            disableDialogTitle={"Disable Automation Rules"}
                            disableDialogContent={<>
                                When you disable, your Microsoft 365 account will also be logged out. Are you sure you want to disable the Automation Rules?
                                <Box className={'info-box'} sx={{marginTop: 2}}>
                                     <strong>If this feature is the last one connected to the tenant</strong>, disabling it <strong>disconnects</strong> the tenant
                                </Box>
                            </>}
                            onDisabled={() => {
                                updateSetting({
                                    task: UPDATE_SETTINGS_TASKS.DISCONNECT_AUTO_BLOCK_LIST,
                                }).then((response) => {
                                    updateSetting({
                                        task: UPDATE_SETTINGS_TASKS.DISCONNECT_AUTO_PHISH_CLEAR,
                                    }).then((response) => {
                                        reloadCredentials()
                                    }).catch(e => {
                                        reloadCredentials()
                                    })
                                }).catch(e => {
                                    reloadCredentials()
                                })

                            }}
                            isSwitchUsed={false}
                        /> }
              {
                isMS365 && <Stack className="manual-actions-settings-wrapper" gap={4}>
                      <Box className="title-domain">
                          <Box sx={{fontSize: "18px"}}> <strong>Manual Actions</strong> for each Reported Email
                              <Tooltip placement={"top"}
                                       sx={{marginLeft: "10px"}}
                                       title={"Enable more actions for a reported email."}
                                       componentsProps={{
                                         tooltip: {
                                           sx: {
                                             width: "auto",
                                             maxWidth: "700px",
                                             fontWeight: 600,
                                             padding: "8px",
                                             position: "relative",
                                             left: "40px"
                                           },
                                         },
                                       }}
                              >
                                  <IconButton className='info-action'><HelpIcon fontSize={'small'}
                                                                                htmlColor={"#193051"}/></IconButton>
                              </Tooltip>
                          </Box>
                      </Box>
                      <Stack direction="row" gap={4} maxWidth="88%">
                          <SettingCard
                              loading={loadingPage}
                              title="Phish Clear"
                              description="Enable Phish Clear"
                              status={setting[SETTING_TYPE_REPORTED_EMAILS_ACTIONS]}
                              type={SETTING_TYPE_REPORTED_EMAILS_ACTIONS}
                              titleFlexDirection="row"
                              showDisableDialog
                              disableDialogTitle={"Disable Manual Phish Clear Action"}
                              disableDialogContent={<>
                                When you disable, your Microsoft 365 account will also be logged out. Are you sure you want
                                to
                                disable the manual Phish Clear action for reported message?
                                <Box className={'info-box'} sx={{ marginTop: 2 }}>
                                  <strong>If this feature is the last one connected to the tenant</strong>, disabling
                                  it <strong>disconnects</strong> the tenant
                                </Box>
                              </>}
                              onDisabled={() => {
                                updateSetting({
                                  task: UPDATE_SETTINGS_TASKS.DISCONNECT_PHISH_CLEAR,
                                }).then((response) => {
                                  reloadCredentials()
                                }).catch(e => {
                                  reloadCredentials()
                                })
                              }}
                              onEnableToggle={() => {
                                reloadCredentials()
                              }}
                              component={setting[SETTING_TYPE_REPORTED_EMAILS_ACTIONS] ? <>
                                <Divider style={{ marginTop: 16, marginBottom: 16 }}/>
                                <CredentialCard
                                  payload={{
                                    service_key: ACCOUNT_DATA_KEYS.PHISH_CLEAR,
                                    service_id: ACCOUNT_DATA_KEYS.PHISH_CLEAR,
                                    title: t("credentialCard.manual_action_title"),
                                    authenticated: manualPhishClearSetting[ACCOUNT_DATA_KEYS.AUTHENTICATED],
                                    accountName: manualPhishClearSetting[ACCOUNT_DATA_KEYS.ACCOUNT_NAME],
                                    accountEmail: manualPhishClearSetting[ACCOUNT_DATA_KEYS.ACCOUNT_EMAIL],
                                    loginAt: manualPhishClearSetting[ACCOUNT_DATA_KEYS.LOGIN_AT],
                                    lastUpdate: manualPhishClearSetting[ACCOUNT_DATA_KEYS.LAST_UPDATE],
                                    expireAt: manualPhishClearSetting[ACCOUNT_DATA_KEYS.EXPIRE_AT],
                                    daysRemaining: manualPhishClearSetting[ACCOUNT_DATA_KEYS.DAYS_REMAINING],
                                  }}
                                  onRemoveCredential={() => {
                                    setLoadingFullPage(true)
                                    updateSetting({
                                      task: UPDATE_SETTINGS_TASKS.REMOVE_PHISH_CLEAR_CREDENTIAL,
                                    }).then((response) => {
                                      reloadCredentials()
                                    }).catch(e => {
                                      setLoadingFullPage(false)
                                    })
                                  }
                                  }
                                  onLogIn={(isReLogin = false) => {
                                    accountsData['onBeforeLogin']?.()
                                    LoginAzure({
                                      service: "setting_phish_clear",
                                      sourceId: "",
                                      isReLogin,
                                    })
                                  }}
                                ></CredentialCard>
                              </> : <></>}
                          />
                          <SettingCard
                              loading={loadingPage}
                              title="Block List"
                              description="Enable Block List"
                              status={setting[SETTING_BLOCK_LIST]}
                              type={SETTING_BLOCK_LIST}
                              titleFlexDirection="row"
                              showDisableDialog
                              disableDialogTitle={"Disable Manual Block List Action"}
                              disableDialogContent={<>
                                When you disable, your Microsoft 365 account will also be logged out. Are you sure you want
                                to
                                disable the manual Block List action for reported message?
                                <Box className={'info-box'} sx={{ marginTop: 2 }}>
                                  <strong>If this feature is the last one connected to the tenant</strong>, disabling
                                  it <strong>disconnects</strong> the tenant
                                </Box>
                              </>}
                              onDisabled={() => {
                                updateSetting({
                                  task: UPDATE_SETTINGS_TASKS.DISCONNECT_BLOCK_LIST
                                }).then((response) => {
                                  reloadCredentials()
                                }).catch(e => {
                                  reloadCredentials()
                                })
                              }}
                              onEnableToggle={() => {
                                reloadCredentials()
                              }}
                              component={setting[SETTING_BLOCK_LIST] ? <>
                                <Divider style={{ marginTop: 16, marginBottom: 16 }}/>
                                <CredentialCard
                                  payload={{
                                    service_key: ACCOUNT_DATA_KEYS.BLOCK_LIST,
                                    service_id: ACCOUNT_DATA_KEYS.BLOCK_LIST,
                                    title: t("credentialCard.manual_action_title"),
                                    authenticated: manualBlocklistSetting[ACCOUNT_DATA_KEYS.AUTHENTICATED],
                                    accountName: manualBlocklistSetting[ACCOUNT_DATA_KEYS.ACCOUNT_NAME],
                                    accountEmail: manualBlocklistSetting[ACCOUNT_DATA_KEYS.ACCOUNT_EMAIL],
                                    loginAt: manualBlocklistSetting[ACCOUNT_DATA_KEYS.LOGIN_AT],
                                    lastUpdate: manualBlocklistSetting[ACCOUNT_DATA_KEYS.LAST_UPDATE],
                                    expireAt: manualBlocklistSetting[ACCOUNT_DATA_KEYS.EXPIRE_AT],
                                    daysRemaining: manualBlocklistSetting[ACCOUNT_DATA_KEYS.DAYS_REMAINING],
                                  }}
                                  onRemoveCredential={() => {
                                    setLoadingFullPage(true)
                                    updateSetting({
                                      task: UPDATE_SETTINGS_TASKS.REMOVE_BLOCK_LIST_CREDENTIAL,
                                    }).then((response) => {
                                      reloadCredentials()
                                    }).catch(e => {
                                      setLoadingFullPage(false)
                                    })
                                  }
                                  }
                                  onLogIn={(isReLogin = false) => {
                                    accountsData['onBeforeLogin']?.()
                                    LoginAzure({
                                      service: "setting_block_list",
                                      sourceId: "",
                                      isReLogin,
                                    })
                                  }}
                                ></CredentialCard>
                              </> : <></>}
                          />
                      </Stack>
                  </Stack>
              }
                {roleUser === ADMIN_ROLE ? <BaseDomainSetting/> : null}
            </Box>
            <LoadingPage open={loadingFullPage}/>
        </Box>
    );
};

export const Settings = ChangeWithZone(SettingFull);
